// -------------------------------------------------------------
// WHATSAPP ADMIN ROTATOR HELPER FOR SATALA DERMATECH ESSENTIAL
import { trackGoogleConversion, trackMetaLead } from './metaPixelTracker';

export const DEFAULT_WA_ADMINS = [
  { id: 1, name: 'Adnan Hasan', phone: '6282321231997', role: 'Marketing 2', active: true, leadsCount: 0 },
  { id: 2, name: 'Ahmad', phone: '6285183147319', role: 'Admin 1', active: true, leadsCount: 0 }
];

const getCookie = (name) => {
  try {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  } catch (e) { return null; }
};

const setCookie = (name, value, days = 365) => {
  try {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};path=/;expires=${d.toUTCString()};SameSite=Lax`;
  } catch (e) {}
};

export const getWaAdmins = () => {
  try {
    const saved = localStorage.getItem('satala_wa_admins');
    if (saved !== null) {
      const parsed = JSON.parse(saved);
      if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    }
  } catch (e) {
    console.error('Error reading WA admins:', e);
  }
  return DEFAULT_WA_ADMINS;
};

export const saveWaAdmins = (admins) => {
  try {
    localStorage.setItem('satala_wa_admins', JSON.stringify(admins));
    window.dispatchEvent(new Event('satala_wa_admins_changed'));
  } catch (e) {
    console.error('Error saving WA admins:', e);
  }
};

export const getNextActiveWaAdmin = () => {
  const admins = getWaAdmins();
  const activeAdmins = admins.filter(a => a.active);

  if (activeAdmins.length === 0) {
    return { name: 'Admin Sales', phone: '6285183147319', role: 'CS Satala', refCode: '#SAT-' + Math.floor(1000 + Math.random() * 8999) };
  }

  // 1. Smart Cookie Loyalty Check: If returning visitor already assigned to active CS, keep same CS!
  const assignedCsId = getCookie('satala_assigned_cs_id');
  let selectedAdmin = null;

  if (assignedCsId) {
    selectedAdmin = activeAdmins.find(a => String(a.id) === String(assignedCsId));
  }

  if (!selectedAdmin) {
    // 2. Weighted Random Pick for new lead
    const minLeads = Math.min(...activeAdmins.map(a => a.leadsCount || 0));
    const candidateAdmins = activeAdmins.filter(a => (a.leadsCount || 0) <= minLeads);
    selectedAdmin = candidateAdmins[Math.floor(Math.random() * candidateAdmins.length)] || activeAdmins[0];
  }

  // Save assigned CS ID to Cookie for 365 Days (1 Full Year)
  setCookie('satala_assigned_cs_id', selectedAdmin.id, 365);

  // Update lead count for stats
  const updatedAdmins = admins.map(a => {
    if (a.id === selectedAdmin.id) {
      return { ...a, leadsCount: (a.leadsCount || 0) + 1 };
    }
    return a;
  });
  saveWaAdmins(updatedAdmins);

  // Generate 100% Unique Verified Reference Code for Webhook Matching
  const refCode = `#SAT-${Math.floor(1000 + Math.random() * 8999)}`;

  // Auto-record Lead in satala_leads_data with precision Traffic Source detection
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = (urlParams.get('utm_source') || urlParams.get('source') || '').toLowerCase();
    const savedUtm = getCookie('satala_first_touch_utm');
    const hasFbClid = urlParams.has('fbclid');

    let source = 'Direct Organik';
    const activeUtm = (utmSource || savedUtm || '').toLowerCase();
    if (activeUtm.includes('meta') || activeUtm.includes('facebook') || activeUtm.includes('instagram') || hasFbClid) source = 'Meta Ads';
    else if (activeUtm.includes('google') || urlParams.has('gclid')) source = 'Google Ads';
    else if (activeUtm.includes('tiktok') || urlParams.has('ttclid')) source = 'TikTok Ads';

    const newLead = {
      id: `lead_${Date.now()}`,
      refCode,
      adminName: selectedAdmin.name,
      adminPhone: selectedAdmin.phone,
      source,
      status: '🟡 KLIK_WA_PENDING',
      statusLabel: '🟡 Klik WA (Intent Prospect)',
      timestamp: new Date().toISOString(),
      page: window.location.pathname
    };

    const savedLeads = localStorage.getItem('satala_leads_data');
    const leads = savedLeads ? JSON.parse(savedLeads) : [];
    leads.unshift(newLead);
    localStorage.setItem('satala_leads_data', JSON.stringify(leads));

    // Trigger Google Ads Conversion & Meta Pixel Lead event
    try {
      if (typeof window !== 'undefined') {
        trackGoogleConversion();
        trackMetaLead(newLead);
      }
    } catch(e){}

    // Register to PHP backend endpoint as well
    fetch('/api/wa-webhook.php?action=receive_webhook', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: newLead.id,
        refCode,
        adminName: selectedAdmin.name,
        source,
        page: window.location.pathname
      })
    }).catch(() => {});
  } catch (e) {
    console.error('Error logging WA lead:', e);
  }

  return {
    ...selectedAdmin,
    refCode,
    customMessageText: encodeURIComponent(`Halo PT. Satala Dermatech Essential, saya tertarik konsultasi maklon kosmetik. [Ref: ${refCode}]`)
  };
};
